import { css, Global } from '@emotion/react';

import {
  getCssVariables,
  getFontFaces,
} from '../../../apps/explore/styles/CSSVariables';

export const WidgetStyles = () => (
  <Global
    styles={() => css`
      :root {
        ${getCssVariables()}
        ${getFontFaces()}

        * {
          box-sizing: border-box;
        }

        --sembo-inspire-s-color-background-important-interactive: #ea143d;
        --sembo-inspire-s-color-background-important-interactive-hover: #b00f2e;
      }
    `}
  />
);
